import { Input } from "@chakra-ui/react";
import { forwardRef } from "react";
import {
  Controller,
  FieldErrors,
  FieldValues,
  useFormContext,
} from "react-hook-form";

import { Field } from "../ui/field.tsx";
import { InputGroup } from "../ui/input-group.tsx";

export type ControlledInputProps = {
  type?: "text" | "password" | "number" | "email";
  label?: string;
  placeholder?: string;
  name: string;
  className?: string;
  id?: string;
  errors?: FieldErrors<FieldValues>;
  disabled?: boolean;
  icon?: string;
  defaultValue?: string;
  dontShowValue?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  showError?: boolean;
};

const ControlledInput = forwardRef<HTMLInputElement, ControlledInputProps>(
  ({
    placeholder,
    name = "",
    disabled = false,
    id,
    type = "text",
    defaultValue = "",
    size = "sm",
    label,
    className,
    dontShowValue = false,
    showError = true,
  }) => {
    const { control } = useFormContext();

    return (
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field, fieldState: { error } }) => (
          <InputGroup className={className}>
            <Field
              invalid={!!error?.message}
              label={label}
              errorText={showError ? error?.message : undefined}
              color={"#000000"}
            >
              <Input
                placeholder={placeholder}
                id={id}
                value={dontShowValue ? "*****" : (field.value ?? "")}
                onChange={field.onChange}
                type={type}
                disabled={disabled}
                variant={"outline"}
                size={size}
                borderWidth={"1px"}
                borderColor={"#d3d3d3"}
                fontSize={"14px"}
                borderRadius={"0.5rem"}
                paddingLeft={"0.5rem"}
              />
            </Field>
          </InputGroup>
        )}
      />
    );
  },
);

ControlledInput.displayName = "ControlledInput";

export default ControlledInput;
